import styled from 'styled-components'

import { getWidthString, toRem, fontType, transition } from './functions'
import { IGridProps } from './types'
import { grid } from './variables'

export const Container = styled.div.attrs({
	className: 'container',
})`
	margin: 0 auto;
	padding-right: ${grid.gutter / 2}px;
	padding-left: ${grid.gutter / 2}px;
	justify-content: center;
	height: 100%;
	width: 100%;

	@media screen and (min-width: ${grid.lg}px) {
		max-width: ${grid.lg}px;
	}
	@media screen and (max-width: ${grid.lg}px) {
		max-width: ${grid.md}px;
	}
	@media screen and (max-width: ${grid.md}px) {
		max-width: ${grid.sm}px;
	}
	@media screen and (max-width: ${grid.sm}px) {
		max-width: ${grid.xs}px;
	}
	@media screen and (max-width: ${grid.xs}px) {
		max-width: 100%;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	}
`

export const Row = styled.div.attrs({
	className: 'row',
})`
	display: flex;
	display: -ms-flexbox;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	margin-right: ${-grid.gutter / 2}px;
	margin-left: ${-grid.gutter / 2}px;
`

export const Column = styled.div.attrs({
	className: 'column',
})<IGridProps>`
	position: relative;
	width: 100%;
	min-height: 1px;
	padding: ${grid.gutter / 2}px;

	@media screen and (min-width: ${grid.lg}px) {
		${({ lg }) => lg && getWidthString(lg)};
	}
	@media screen and (max-width: ${grid.lg}px) {
		${({ lg }) => lg && getWidthString(lg)};
	}
	@media screen and (max-width: ${grid.md}px) {
		${({ md }) => md && getWidthString(md)};
	}
	@media screen and (max-width: ${grid.sm}px) {
		${({ sm }) => sm && getWidthString(sm)};
	}
	@media screen and (max-width: ${grid.xs}px) {
		${({ xs }) => (xs ? getWidthString(xs) : 'max-width: 100%')};
	}
`

export const ButtonGhostWrapper = styled.button`
	background: transparent;
	color: ${({ theme }) => theme.colors.blue};
	border: 1px solid ${({ theme }) => theme.colors.blue};
	border-radius: 29px;
	padding: 4px 8px;
	font-size: ${toRem(10)};

	cursor: pointer;
	${fontType(0)};
	${transition()};

	&:hover {
		background: ${({ theme }) => theme.colors.lightBlue};
		opacity: 0.8;
	}

	&:active {
		background: ${({ theme }) => theme.colors.lightBlue};
		${transition(0)}
	}

	&[disabled] {
		background: ${({ theme }) => theme.colors.grey};
		cursor: not-allowed;
		opacity: 1;
	}
`
